// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import ScrollToTop from "./components/scroll-to-top";
import { StyledChart } from "./components/chart";
import LoginPage from "./pages/LoginPage";
import AlertsContainer from "./components/AlertsContainer";

// ----------------------------------------------------------------------

export default function App() {
  //localStorage.removeItem("token");
  const token = localStorage.getItem("adminToken");

  if (!token) {
    // Store current URL to redirect back after login
    if (window.location.pathname !== "/login") {
      localStorage.setItem(
        "redirectAfterLogin",
        window.location.pathname + window.location.search
      );
    }
    return (
      <ThemeProvider>
        <LoginPage />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <AlertsContainer />
      <Router />
    </ThemeProvider>
  );
}
